import axios from 'axios'
import { Answer, SchemaType } from '@verifiedit/form-generator'

export type SpotCheckForm = {
  id: number
  type: string
  form: {
    template: {
      components: SchemaType[]
    }
  }
}

export async function getForm(customerId: number): Promise<SpotCheckForm> {
  const response = await axios.get(`api/spot-check-forms/${customerId}`)

  return response.data.data
}

export async function submitSpotCheck(
  customerId: number,
  permitFormSubmissionId: number,
  formData: Map<string, Answer>,
  formId: number,
) {
  const response = await axios.post(`api/spot-check-submission`, {
    customerId: customerId,
    formData: Object.fromEntries(formData),
    formId: formId,
    permitFormSubmissionId: permitFormSubmissionId,
  })

  return response.data.data
}
